export const USERS = {
    login: "login",
    createUser: "createUsuarioSupervisor",
    getUsers: "getUsers",
    changePassword: "changePassword"
};

export const FORM = {
    form: "createForm",
    getForms: "forms",
    deleteForm: "deleteForm",
    updateForm: "updateForm"
}
